/**
 * 统一监控平台相关action
 */
// import oData from '../server/odatayft';
import oData from '../server/odata_client';
import oData_equipment from '../server/odata_equipment_client';
import rData from '../server/rest_client';
import equipmentOdata from '../server/odata_equipment_client';
import * as ofbiz from '../server/ofbiz';
import * as requestDataActions from './requestData_action';
import nls from '../script/properties';
import Util from '../script/utils.js';
import { getMonitorLocale } from './equipment_action';
import { createOperationAudit } from './operationAudit_action';


export const SET_GROUPALLCOLUMNDATA = 'SET_GROUPALLCOLUMNDATA'
export const SET_GROUPALLSHOWCOLUMNDATA = 'SET_GROUPALLSHOWCOLUMNDATA'
export const SET_GROUPTABLEDATA = 'SET_GROUPTABLEDATA'
export const SET_GROUPTABLECOUNT = 'SET_GROUPTABLECOUNT'
export const SET_TEARMALLMAPDATA = 'SET_TEARMALLMAPDATA'
export const SET_TEARMEQUIPMENTTYPEDATA = 'SET_TEARMEQUIPMENTTYPEDATA'
export const SET_TEARMEQUIPMENTNAMEDATA = 'SET_TEARMEQUIPMENTNAMEDATA'
export const SET_SELECTEDTEARMEQUIPMENTNAMEDATA = 'SET_SELECTEDTEARMEQUIPMENTNAMEDATA'
export const SET_TEARMSUBMAPDATA = 'SET_TEARMSUBMAPDATA'
export const SET_MONITORTREE_COMP = 'SET_MONITORTREE_COMP'
export const SET_MONITORVIEW = 'SET_MONITORVIEW'
export const SET_PIECHARTMONITORTYPE = 'SET_PIECHARTMONITORTYPE'
export const SET_MONITORNAME = 'SET_MONITORNAME'
export const SET_MONITORGROUPID = 'SET_MONITORGROUPID'
export const SET_MONITORTYPEDEVICE = 'SET_MONITORTYPEDEVICE'
export const SET_MONITORTABLECOLUMNS = 'SET_MONITORTABLECOLUMNS'
export const SET_BCLICKTREENODE = 'SET_BCLICKTREENODE'
export const SET_GETTEARMLISTDATATYPE = 'SET_GETTEARMLISTDATATYPE'
export const SET_PIECHARTDATATYPE = 'SET_PIECHARTDATATYPE'
export const SET_TEARMALLMAPDATA_PIECHARTMONITORTYPERADIO = 'SET_TEARMALLMAPDATA_PIECHARTMONITORTYPERADIO'
export const SET_TEARMALLMAPDATA_MONITORTYPERADIO = 'SET_TEARMALLMAPDATA_MONITORTYPERADIO'
export const SET_TEARMEQUIPMENTTYPEDATA_MONITORTYPERADIO = 'SET_TEARMEQUIPMENTTYPEDATA_MONITORTYPERADIO'
export const SET_TEARMEQUIPMENTNAMEDATA_MONITORTYPERADIO = 'SET_TEARMEQUIPMENTNAMEDATA_MONITORTYPERADIO'
export const SET_TEARMSUBMAPDATA_MONITORTYPERADIO = 'SET_TEARMSUBMAPDATA_MONITORTYPERADIO'
export const SET_TEARMMAPDATA_MONITORTYPERADIO = 'SET_TEARMMAPDATA_MONITORTYPERADIO'
export const SET_TEARMMAPDATA_MONITORTYPERADIO_SINGLE = 'SET_TEARMMAPDATA_MONITORTYPERADIO_SINGLE'
export const SET_STATUSGRIDMONITORGROUPID = 'SET_STATUSGRIDMONITORGROUPID'
export const SET_MONITORTABLESELECTEDROWDATA = 'SET_MONITORTABLESELECTEDROWDATA'
export const SET_MONITORTABLESELECTEDROWDATA_FIELD = 'SET_MONITORTABLESELECTEDROWDATA_FIELD'
export const SET_SEARCHAREADATA = 'SET_SEARCHAREADATA'
export const SET_SETTINGSEARCHAREADATA = 'SET_SETTINGSEARCHAREADATA'
export const SET_MONITORTABLECURRENTPAGE = 'SET_MONITORTABLECURRENTPAGE'
export const SET_MONITORTABLENUMPERPAGE = 'SET_MONITORTABLENUMPERPAGE'
export const SET_MONITORTABLEFILTER = 'SET_MONITORTABLEFILTER'
export const SET_MONITORFILTERSTATUS = 'SET_MONITORFILTERSTATUS'
export const SET_FILTEREDGROUPTABLEDATA = 'SET_FILTEREDGROUPTABLEDATA'
export const SET_YFTALARMDATA = 'SET_YFTALARMDATA'
export const SET_YFTALARMRULEDATA = 'SET_YFTALARMRULEDATA'
export const SET_ERRORALARMTEXT = 'SET_ERRORALARMTEXT'
export const SET_WARNINGALARMTEXT = 'SET_WARNINGALARMTEXT'
export const SET_GOODALARMTEXT = 'SET_GOODALARMTEXT'
export const SET_ERRORCONDITIONSDATA = 'SET_ERRORCONDITIONSDATA'
export const SET_SETTINGERRORCONDITIONSDATA = 'SET_SETTINGERRORCONDITIONSDATA'
export const SET_ISORERROR = 'SET_ISORERROR'
export const SET_SETTINGISORERROR = 'SET_SETTINGISORERROR'
export const SET_WARNINGCONDITIONSDATA = 'SET_WARNINGCONDITIONSDATA'
export const SET_SETTINGWARNINGCONDITIONSDATA = 'SET_SETTINGWARNINGCONDITIONSDATA'
export const SET_ISORWARNING = 'SET_ISORWARNING'
export const SET_SETTINGISORWARNING = 'SET_SETTINGISORWARNING'
export const SET_GOODCONDITIONSDATA = 'SET_GOODCONDITIONSDATA'
export const SET_SETTINGGOODCONDITIONSDATA = 'SET_SETTINGGOODCONDITIONSDATA'
export const SET_ISORGOOD = 'SET_ISORGOOD'
export const SET_SETTINGISORGOOD = 'SET_SETTINGISORGOOD'
export const SET_ALARMISSUEDTABLEDATA = 'SET_ALARMISSUEDTABLEDATA'
export const SET_ALARMISSUEDEQUIPMENTTYPE = 'SET_ALARMISSUEDEQUIPMENTTYPE'
export const SET_ALARMISSUEDMONITORTYPE = 'SET_ALARMISSUEDMONITORTYPE'
export const SET_ALARMEVENTDATA = 'SET_ALARMEVENTDATA'
export const SET_ALARMEVENTCOUNT = 'SET_ALARMEVENTCOUNT'
export const SET_SELECTEDALARMEVENT = 'SET_SELECTEDALARMEVENT'
export const SET_ALARMEVENTCURRENTPAGE = 'SET_ALARMEVENTCURRENTPAGE'
export const SET_ALARMEVENTNUMPERPAGE = 'SET_ALARMEVENTNUMPERPAGE'
export const SET_ALARMEVENTFILTER = 'SET_ALARMEVENTFILTER'
export const SET_ALARMEVENTDETAILS = 'SET_ALARMEVENTDETAILS'
export const SET_ALARMEVENTDETAILMODALOPENEDFROMPAGE = 'SET_ALARMEVENTDETAILMODALOPENEDFROMPAGE'
export const SET_ISCREATEWORKORDER = 'SET_ISCREATEWORKORDER'
export const SET_VIDEOLOSSDATA = 'SET_VIDEOLOSSDATA'
export const SET_BSHOWVIDEOLOSSTAB = 'SET_BSHOWVIDEOLOSSTAB'
export const SET_CHANNELINFODATA = 'SET_CHANNELINFODATA'
export const SET_SIPID = 'SET_SIPID'
export const SET_ALARMEVENTPAGE_CURRENTFILTER = 'SET_ALARMEVENTPAGE_CURRENTFILTER'
export const SET_CHILDRENGROUP = 'SET_CHILDRENGROUP'
export const SET_CHILDRENEQUIP = 'SET_CHILDRENEQUIP'
export const SET_CHILDRENMONITOR = 'SET_CHILDRENMONITOR'
export const SET_SELECTEDDEVICEGROUP = 'SET_SELECTEDDEVICEGROUP'
export const SET_THRESHOLDLIST = 'SET_THRESHOLDLIST'
export const SET_MONITORSUMMARYDATA = 'SET_MONITORSUMMARYDATA'
export const SET_MONITOR_STATE_DATA = 'SET_MONITOR_STATE_DATA';
export const SET_MONITOR_LOG_DATA = 'SET_MONITOR_LOG_DATA';
export const SET_SERVERCURRENTTIME = 'SET_SERVERCURRENTTIME';
export const SET_NOREFRESHMONITORVIEWFLAG = 'SET_NOREFRESHMONITORVIEWFLAG';
export const SET_COMPAREREPORTDATA = 'SET_COMPAREREPORTDATA';
export const SET_RESOURCEVIEWTYPE = 'SET_RESOURCEVIEWTYPE';
export const SET_RESOURCEEDIT = 'SET_RESOURCEEDIT';
export const SET_CHECKLOGSEARCHDATA = 'SET_CHECKLOGSEARCHDATA';

export function setResourceEdit(resourceEdit) {
  return {
    type: SET_RESOURCEEDIT,
    resourceEdit
  }
}

export function setCheckLogSearchData(checkLogSearchData) {
  return {
    type: SET_CHECKLOGSEARCHDATA,
    checkLogSearchData
  }
}

export function setCompareReportData(compareReportData) {
  return {
    type: SET_COMPAREREPORTDATA,
    compareReportData
  }
}

export function setServerCurrentTime(serverCurrentTime) {
  return {
    type: SET_SERVERCURRENTTIME,
    serverCurrentTime
  }
}

export function setThresholdList(thresholdList){
  return {
    type: SET_THRESHOLDLIST,
    thresholdList
  }
}

export function setMonitorSummaryData(monitorSummaryData){
  return {
    type: SET_MONITORSUMMARYDATA,
    monitorSummaryData
  }
}

export function setMonitorStateData(monitorStateData){
  return {
    type: SET_MONITOR_STATE_DATA,
    monitorStateData
  }
}

export function setMonitorLogData(monitorLogData){
  return {
    type: SET_MONITOR_LOG_DATA,
    monitorLogData
  }
}

export function setSelectedDeviceGroup(dGroup){
  return {
    type: SET_SELECTEDDEVICEGROUP,
    dGroup
  }
}

export function setChildrenEquip(cEquip){
  return {
    type: SET_CHILDRENEQUIP,
    cEquip
  }
}

export function setChildrenGroup(cGroup){
  return {
    type: SET_CHILDRENGROUP,
    cGroup
  }
}

export function setChildrenMonitor(cMonitor){
  return {
    type: SET_CHILDRENMONITOR,
    cMonitor
  }
}
//组列表全部列数据
export function setGroupAllColumnData(groupAllColumnData) {
    return {
        type: SET_GROUPALLCOLUMNDATA,
        groupAllColumnData
    }
}
//组列表当前显的列数据
export function setGroupAllShowColumnData(groupAllShowColumnData) {
    return {
        type: SET_GROUPALLSHOWCOLUMNDATA,
        groupAllShowColumnData
    }
}
//组列表当前显的数据
export function setGroupTableData(groupTableData) {
    return {
        type: SET_GROUPTABLEDATA,
        groupTableData
    }
}

export function setGroupTableCount(groupTableCount) {
    return {
        type: SET_GROUPTABLECOUNT,
        groupTableCount
    }
}

export function setTearmAllMAPData(tearmAllMAPData) {
    return {
        type: SET_TEARMALLMAPDATA,
        tearmAllMAPData
    }
}

export function setTearmEquipmentTypeData(tearmEquipmentTypeData) {
    return {
        type: SET_TEARMEQUIPMENTTYPEDATA,
        tearmEquipmentTypeData
    }
}

export function setTearmEquipmentNameData(tearmEquipmentNameData) {
    return {
        type: SET_TEARMEQUIPMENTNAMEDATA,
        tearmEquipmentNameData
    }
}

export function setSelectedTearmEquipmentNameData(selectedTearmEquipmentNameData) {
    return {
        type: SET_SELECTEDTEARMEQUIPMENTNAMEDATA,
        selectedTearmEquipmentNameData
    }
}

export function setTearmSubMAPData(tearmSubMAPData) {
    return {
        type: SET_TEARMSUBMAPDATA,
        tearmSubMAPData
    }
}

export function setMonitorTreeComp(monitorTreeComp) {
    return {
        type: SET_MONITORTREE_COMP,
        monitorTreeComp
    }
}

export function setNoRefreshMonitorViewFlag(noRefreshMonitorViewFlag) {
    return {
        type: SET_NOREFRESHMONITORVIEWFLAG,
        noRefreshMonitorViewFlag
    }
}

export function setMonitorView(monitorView) {
    return {
        type: SET_MONITORVIEW,
        monitorView
    }
}

export function setPieChartMonitorType(pieChartMonitorType) {
    return {
        type: SET_PIECHARTMONITORTYPE,
        pieChartMonitorType
    }
}

export function setMonitorName(monitorName) {
    return {
        type: SET_MONITORNAME,
        monitorName
    }
}

export function setMonitorGroupId(monitorGroupId) {
    return {
        type: SET_MONITORGROUPID,
        monitorGroupId
    }
}

export function setMonitorTypeDevice(monitorTypeDevice) {
    return {
        type: SET_MONITORTYPEDEVICE,
        monitorTypeDevice
    }
}

export function setMonitorTableColumns(monitorTableColumns) {
    return {
        type: SET_MONITORTABLECOLUMNS,
        monitorTableColumns
    }
}

export function setbClickTreeNode(bClickTreeNode) {
    return {
        type: SET_BCLICKTREENODE,
        bClickTreeNode
    }
}

export function setGetTearmListDataType(getTearmListDataType) {
    return {
        type: SET_GETTEARMLISTDATATYPE,
        getTearmListDataType
    }
}

export function setPieChartDataType(pieChartDataType) {
    return {
        type: SET_PIECHARTDATATYPE,
        pieChartDataType
    }
}

export function setTearmAllMAPData_pieChartMonitorTypeRadio(tearmAllMAPData_pieChartMonitorTypeRadio) {
    return {
        type: SET_TEARMALLMAPDATA_PIECHARTMONITORTYPERADIO,
        tearmAllMAPData_pieChartMonitorTypeRadio
    }
}

export function setTearmAllMAPData_monitorTypeRadio(tearmAllMAPData_monitorTypeRadio) {
    return {
        type: SET_TEARMALLMAPDATA_MONITORTYPERADIO,
        tearmAllMAPData_monitorTypeRadio
    }
}

export function setTearmEquipmentTypeData_monitorTypeRadio(tearmEquipmentTypeData_monitorTypeRadio) {
    return {
        type: SET_TEARMEQUIPMENTTYPEDATA_MONITORTYPERADIO,
        tearmEquipmentTypeData_monitorTypeRadio
    }
}

export function setTearmEquipmentNameData_monitorTypeRadio(tearmEquipmentNameData_monitorTypeRadio) {
    return {
        type: SET_TEARMEQUIPMENTNAMEDATA_MONITORTYPERADIO,
        tearmEquipmentNameData_monitorTypeRadio
    }
}

export function setTearmSubMAPData_monitorTypeRadio(tearmSubMAPData_monitorTypeRadio) {
    return {
        type: SET_TEARMSUBMAPDATA_MONITORTYPERADIO,
        tearmSubMAPData_monitorTypeRadio
    }
}

export function setTearmMAPData_monitorTypeRadio(tearmMAPData_monitorTypeRadio) {
    return {
        type: SET_TEARMMAPDATA_MONITORTYPERADIO,
        tearmMAPData_monitorTypeRadio
    }
}

export function setTearmMAPData_monitorTypeRadio_single(tearmMAPData_monitorTypeRadio_single, index) {
    return {
        type: SET_TEARMMAPDATA_MONITORTYPERADIO_SINGLE,
        tearmMAPData_monitorTypeRadio_single,
        index
    }
}

export function setStatusGridMonitorGroupId(statusGridMonitorGroupId) {
    return {
        type: SET_STATUSGRIDMONITORGROUPID,
        statusGridMonitorGroupId
    }
}

export function setMonitorTableSelectedRowData(monitorTableSelectedRowData) {
    return {
        type: SET_MONITORTABLESELECTEDROWDATA,
        monitorTableSelectedRowData
    }
}

export function setMonitorTableSelectedRowDataField(LAG, BRAND) {
    return {
        type: SET_MONITORTABLESELECTEDROWDATA_FIELD,
        LAG,
        BRAND
    }
}

export function setSearchAreaData(searchAreaData) {
    return {
        type: SET_SEARCHAREADATA,
        searchAreaData
    }
}

export function setSettingSearchAreaData(settingSearchAreaData) {
    return {
        type: SET_SETTINGSEARCHAREADATA,
        settingSearchAreaData
    }
}

export function setMonitorTableCurrentPage(monitorTableCurrentPage) {
    return {
        type: SET_MONITORTABLECURRENTPAGE,
        monitorTableCurrentPage
    }
}

export function setMonitorTableNumPerPage(monitorTableNumPerPage) {
    return {
        type: SET_MONITORTABLENUMPERPAGE,
        monitorTableNumPerPage
    }
}

export function setMonitorTableFilter(monitorTableFilter) {
    return {
        type: SET_MONITORTABLEFILTER,
        monitorTableFilter
    }
}

export function setMonitorFilterStatus(monitorFilterStatus) {
    return {
        type: SET_MONITORFILTERSTATUS,
        monitorFilterStatus
    }
}

export function setFilteredGroupTableData(filteredGroupTableData) {
    return {
        type: SET_FILTEREDGROUPTABLEDATA,
        filteredGroupTableData
    }
}

export function setYFTAlarmData(yftAlarmData) {
    return {
        type: SET_YFTALARMDATA,
        yftAlarmData
    }
}

export function setYFTAlarmRuleData(yftAlarmRuleData) {
    return {
        type: SET_YFTALARMRULEDATA,
        yftAlarmRuleData
    }
}

export function setErrorAlarmText(errorAlarmText) {
    return {
        type: SET_ERRORALARMTEXT,
        errorAlarmText
    }
}

export function setWarningAlarmText(warningAlarmText) {
    return {
        type: SET_WARNINGALARMTEXT,
        warningAlarmText
    }
}

export function setGoodAlarmText(goodAlarmText) {
    return {
        type: SET_GOODALARMTEXT,
        goodAlarmText
    }
}

export function setErrorConditionsData(errorConditionsData) {
    return {
        type: SET_ERRORCONDITIONSDATA,
        errorConditionsData
    }
}

export function setSettingErrorConditionsData(settingErrorConditionsData) {
    return {
        type: SET_SETTINGERRORCONDITIONSDATA,
        settingErrorConditionsData
    }
}

export function setIsOrError(isOrError) {
    return {
        type: SET_ISORERROR,
        isOrError
    }
}

export function setSettingIsOrError(settingIsOrError) {
    return {
        type: SET_SETTINGISORERROR,
        settingIsOrError
    }
}

export function setWarningConditionsData(warningConditionsData) {
    return {
        type: SET_WARNINGCONDITIONSDATA,
        warningConditionsData
    }
}

export function setSettingWarningConditionsData(settingWarningConditionsData) {
    return {
        type: SET_SETTINGWARNINGCONDITIONSDATA,
        settingWarningConditionsData
    }
}

export function setIsOrWarning(isOrWarning) {
    return {
        type: SET_ISORWARNING,
        isOrWarning
    }
}

export function setSettingIsOrWarning(settingIsOrWarning) {
    return {
        type: SET_SETTINGISORWARNING,
        settingIsOrWarning
    }
}

export function setGoodConditionsData(goodConditionsData) {
    return {
        type: SET_GOODCONDITIONSDATA,
        goodConditionsData
    }
}

export function setSettingGoodConditionsData(settingGoodConditionsData) {
    return {
        type: SET_SETTINGGOODCONDITIONSDATA,
        settingGoodConditionsData
    }
}

export function setIsOrGood(isOrGood) {
    return {
        type: SET_ISORGOOD,
        isOrGood
    }
}

export function setSettingIsOrGood(settingIsOrGood) {
    return {
        type: SET_SETTINGISORGOOD,
        settingIsOrGood
    }
}

export function setAlarmIssuedTableData(alarmIssuedTableData) {
    return {
        type: SET_ALARMISSUEDTABLEDATA,
        alarmIssuedTableData
    }
}

export function setAlarmIssuedEquipmentType(alarmIssuedEquipmentType) {
    return {
        type: SET_ALARMISSUEDEQUIPMENTTYPE,
        alarmIssuedEquipmentType
    }
}

export function setAlarmIssuedMonitorType(alarmIssuedMonitorType) {
    return {
        type: SET_ALARMISSUEDMONITORTYPE,
        alarmIssuedMonitorType
    }
}

export function setAlarmEventData(alarmEventData) {
    return {
        type: SET_ALARMEVENTDATA,
        alarmEventData
    }
}

export function setAlarmEventCount(alarmEventCount) {
    return {
        type: SET_ALARMEVENTCOUNT,
        alarmEventCount
    }
}

export function setSelectedAlarmEvent(selectedAlarmEvent) {
    return {
        type: SET_SELECTEDALARMEVENT,
        selectedAlarmEvent
    }
}

export function setAlarmEventCurrentPage(alarmEventCurrentPage) {
    return {
        type: SET_ALARMEVENTCURRENTPAGE,
        alarmEventCurrentPage
    }
}

export function setAlarmEventNumPerPage(alarmEventNumPerPage) {
    return {
        type: SET_ALARMEVENTNUMPERPAGE,
        alarmEventNumPerPage
    }
}

export function setAlarmEventFilter(alarmEventFilter) {
    return {
        type: SET_ALARMEVENTFILTER,
        alarmEventFilter
    }
}

export function setAlarmEventDetails(alarmEventDetails) {
    return {
        type: SET_ALARMEVENTDETAILS,
        alarmEventDetails
    }
}

export function setAlarmEventDetailModalOpenedFromPage(alarmEventDetailModalOpenedFromPage) {
    return {
        type: SET_ALARMEVENTDETAILMODALOPENEDFROMPAGE,
        alarmEventDetailModalOpenedFromPage
    }
}

export function setIsCreateWorkOrder(isCreateWorkOrder) {
    return {
        type: SET_ISCREATEWORKORDER,
        isCreateWorkOrder
    }
}

export function setVideoLossData(videoLossData) {
    return {
        type: SET_VIDEOLOSSDATA,
        videoLossData
    }
}

export function setbShowVideoLossTab(bShowVideoLossTab) {
    return {
        type: SET_BSHOWVIDEOLOSSTAB,
        bShowVideoLossTab
    }
}

export function setChannelInfoData(channelInfoData) {
    return {
        type: SET_CHANNELINFODATA,
        channelInfoData
    }
}

export function setSipid(sipid) {
    return {
        type: SET_SIPID,
        sipid
    }
}

export function setAlarmEventPageCurrentFilter(currentFilter) {
    return {
        type: SET_ALARMEVENTPAGE_CURRENTFILTER,
        currentFilter
    }
}

export function setResourceViewType(resourceViewType) {
    return {
        type: SET_RESOURCEVIEWTYPE,
        resourceViewType
    }
}

export function receiveCreateOperationAudit(param) {
    return dispatch => {
      dispatch(createOperationAudit(param));
    }
}

function receiveGetGroupList(data) {
    return (dispatch, getState) => {
        var state = getState();
        if(data.results.length == 0){
            dispatch(requestDataActions.setRequestFail());
            // _this.emit("change");
            return;
        };
        var tempdata = data.results[0];
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataobj = eval(tempdata);
        var aLL_DATA = dataobj.ALL_DATA;
        aLL_DATA = eval('('+aLL_DATA+')');//将json对像转成数组
        // _this.groupAllColumnData=aLL_DATA;//组列表全部列数据
        dispatch(setGroupAllColumnData(aLL_DATA));
        var monitorTableColumns = [];
        for(var i=0; i<aLL_DATA.length; i++) {
            if(aLL_DATA[i].isshow == "1"){
                monitorTableColumns.push(aLL_DATA[i]);
            }
        }
        dispatch(setMonitorTableColumns(monitorTableColumns));

        var sHOW_DATA = dataobj.SHOW_DATA;
        sHOW_DATA = eval('('+sHOW_DATA+')');//将json对像转成数组
        // _this.groupAllShowColumnData=sHOW_DATA;//组列表当前显的列数据
        dispatch(setGroupAllShowColumnData(sHOW_DATA));

        var tABLE_DATA = dataobj.TABLE_DATA;
        tABLE_DATA = eval('('+tABLE_DATA+')');//将json对像转成数组
        // _this.groupTableData=tABLE_DATA;//组列表当前显的数据
        // _this.groupTableCount = eval(dataobj.COUNT);
        // _this.filteredGroupTableData = tABLE_DATA;
        dispatch(setGroupTableData(tABLE_DATA));
        dispatch(setGroupTableCount(eval(dataobj.COUNT)));
        dispatch(setFilteredGroupTableData(tABLE_DATA));

        var aLL_MAP = dataobj.ALL_MAP;
        aLL_MAP = eval('('+aLL_MAP+')');//将json对像转成数组
        // _this.tearmAllMAPData=aLL_MAP;
        dispatch(setTearmAllMAPData(aLL_MAP));

        // _this.monitorFilterStatus = "all";
        dispatch(requestDataActions.setRequestSuccess());
        // _this.emit("change");
    }
}

function oDataGetGroupList(filter) {
    return dispatch => {
        oData.getGroupList(filter, data => dispatch(receiveGetGroupList(data)));
    }
}

export function getGroupListData(filter) {
    return dispatch => {
        dispatch(setbClickTreeNode(false));
        dispatch(setTearmAllMAPData([]));
        dispatch(setGroupAllColumnData([]));
        dispatch(setMonitorTableColumns([]));
        dispatch(setGroupTableData([]));
        dispatch(setGroupAllShowColumnData([]));
        for(var i = 0; i < filter.length; i++) {
            if(filter[i].key == "TYPE") {
                dispatch(setMonitorTypeDevice(filter[i].value));
                break;
            }
        }
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetGroupList(filter));
    }
}

export function getGroupListDataByClickTree(filter) {
    return (dispatch, getState) => {
        var state = getState();
        // if(state.deviceMonitorReducer.bClickTreeNode) {
            // this.bClickTreeNode = false;
            dispatch(setbClickTreeNode(false));
            dispatch(setTearmAllMAPData([]));
            dispatch(setGroupAllColumnData([]));
            dispatch(setMonitorTableColumns([]));
            dispatch(setGroupTableData([]));
            dispatch(setGroupAllShowColumnData([]));
            for(var i = 0; i < filter.length; i++) {
                if(filter[i].key == "TYPE") {
                    dispatch(setMonitorTypeDevice(filter[i].value));
                    break;
                }
            }
            dispatch(requestDataActions.setRequest());
            return dispatch(oDataGetGroupList(filter));
        // }
    }
}

function receiveGetTearmList(filter, data) {
    return (dispatch, getState) => {
        var state = getState();
        if(data.results.length == 0){
            dispatch(requestDataActions.setRequestFail());
            // _this.emit("change");
            return;
        };
        var tempdata = data.results[0];
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataobj = eval(tempdata);
        var aLL_MAP = dataobj.ALL_MAP;
        aLL_MAP = eval('('+aLL_MAP+')');//将json对像转成数组
        switch (state.deviceMonitorReducer.getTearmListDataType) {
            case 0:
                // _this.tearmAllMAPData=aLL_MAP;
                dispatch(setTearmAllMAPData(aLL_MAP));
                break;
            case 1:
                // _this.tearmAllMAPData_pieChartMonitorTypeRadio=aLL_MAP;
                dispatch(setTearmAllMAPData_pieChartMonitorTypeRadio(aLL_MAP));
                break;
            case 2:
                // _this.tearmAllMAPData_monitorTypeRadio=aLL_MAP;
                dispatch(setTearmAllMAPData_monitorTypeRadio(aLL_MAP));
                break;
            default:
                // _this.tearmAllMAPData=aLL_MAP;
                dispatch(setTearmAllMAPData(aLL_MAP));
                break;
        }
        var eQUIPMENT_NAME = dataobj.EQUIPMENT_NAME;
        eQUIPMENT_NAME = eval('('+eQUIPMENT_NAME+')');//将json对像转成数组
        // _this.getTearmListDataType==0 ? _this.tearmEquipmentNameData=eQUIPMENT_NAME : _this.tearmEquipmentNameData_monitorTypeRadio=eQUIPMENT_NAME;
        state.deviceMonitorReducer.getTearmListDataType==0 ? dispatch(setTearmEquipmentNameData(eQUIPMENT_NAME)) : dispatch(setTearmEquipmentNameData_monitorTypeRadio(eQUIPMENT_NAME));
        var eQUIPMENT_TYPE = dataobj.EQUIPMENT_TYPE;
        eQUIPMENT_TYPE = eval('('+eQUIPMENT_TYPE+')');//将json对像转成数组
        // _this.getTearmListDataType==0 ? _this.tearmEquipmentTypeData=eQUIPMENT_TYPE : _this.tearmEquipmentTypeData_monitorTypeRadio=eQUIPMENT_TYPE;
        state.deviceMonitorReducer.getTearmListDataType==0 ? dispatch(setTearmEquipmentTypeData(eQUIPMENT_TYPE)) : dispatch(setTearmEquipmentTypeData_monitorTypeRadio(eQUIPMENT_TYPE));
        var sUB_MAP = dataobj.SUB_MAP;
        sUB_MAP = eval('('+sUB_MAP+')');//将json对像转成数组
        // _this.getTearmListDataType==0 ? _this.tearmSubMAPData=sUB_MAP : _this.tearmSubMAPData_monitorTypeRadio=sUB_MAP;
        state.deviceMonitorReducer.getTearmListDataType==0 ? dispatch(setTearmSubMAPData(sUB_MAP)) : dispatch(setTearmSubMAPData_monitorTypeRadio(sUB_MAP));
        // if(_this.getTearmListDataType != 2) {
        //     _this.tearmMAPData_monitorTypeRadio = sUB_MAP;
        // }
        if(state.deviceMonitorReducer.getTearmListDataType != 2) {
            // _this.tearmMAPData_monitorTypeRadio = sUB_MAP;
            dispatch(setTearmMAPData_monitorTypeRadio(sUB_MAP));
        }
        else {
            // for(var i = 0; i < _this.tearmMAPData_monitorTypeRadio.length; i++) {
            //     if(_this.tearmMAPData_monitorTypeRadio[i].GROUPID == filter[0].value) {
            //         _this.tearmMAPData_monitorTypeRadio[i].good = aLL_MAP.good;
            //         _this.tearmMAPData_monitorTypeRadio[i].error = aLL_MAP.error;
            //         _this.tearmMAPData_monitorTypeRadio[i].warning = aLL_MAP.warning;
            //         _this.tearmMAPData_monitorTypeRadio[i].sum = aLL_MAP.sum;
            //         break;
            //     }
            // }
            for(var i = 0; i < state.deviceMonitorReducer.tearmMAPData_monitorTypeRadio.length; i++) {
                if(state.deviceMonitorReducer.tearmMAPData_monitorTypeRadio[i].GROUPID == filter[0].value) {
                    dispatch(setTearmMAPData_monitorTypeRadio_single(aLL_MAP, i));
                    break;
                }
            }
        }

        for (var i = 0; i < filter.length; i++) {
            if(filter[i].bSearchBox_monitorType == "true"){
                // _this.onSetMonitorName(filter[i].groupName+"("+(parseInt(aLL_MAP.good)+parseInt(aLL_MAP.warning))+"/"+parseInt(aLL_MAP.sum)+")");
                dispatch(setMonitorName(filter[i].groupName+"("+(parseInt(aLL_MAP.good)+parseInt(aLL_MAP.warning))+"/"+parseInt(aLL_MAP.sum)+")"));
            }
        }
        dispatch(requestDataActions.setRequestSuccess());
        // _this.emit("change");
    }
}

function oDataGetTearmList(filter) {
    return dispatch => {
		oData.getTearmList(filter, data => dispatch(receiveGetTearmList(filter, data)));
    }
}

export function getTearmListData(filter) {
    return dispatch => {
        dispatch(setTearmAllMAPData([]));
        dispatch(setTearmAllMAPData_pieChartMonitorTypeRadio([]));
        dispatch(setTearmAllMAPData_monitorTypeRadio([]));
        for(var i = 0; i < filter.length; i++) {
            if(filter[i].key == "TYPE") {
                dispatch(setMonitorTypeDevice(filter[i].value));
                break;
            }
        }
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetTearmList(filter));
    }
}

// function receiveSetDisplayOrder(data) {
//     return dispatch => {
//         if(data.results.length == 0){
//             // _this.emit("change");
//             dispatch(requestDataActions.setRequestFail());
//             return;
//         };
//         var dataObj = eval(data.results[0]);
//         // _this.emit("change");
//         dispatch(requestDataActions.setRequestSuccess());
//     }
// }

// function oDataSetDisplayOrder(filter) {
//     return dispatch => {
// 		oData.setDisplayOrder(filter, data => dispatch(receiveSetDisplayOrder(data)));
//     }
// }

export function initializeMonitorTableColumns(columns) {
    return dispatch => {
        dispatch(setGroupAllColumnData(columns));
        var monitorTableColumns = [];
        for(var i=0; i<columns.length; i++) {
            if(columns[i].isshow == "1"){
                monitorTableColumns.push(columns[i]);
            }
        };
        dispatch(setMonitorTableColumns(monitorTableColumns));

        var filter = [{key:"DISPLAYORDER",value:JSON.stringify(columns)}];
        dispatch(requestDataActions.setRequest());
        oData.setDisplayOrder(filter, function(data){
            if(data.results.length == 0){
                dispatch(requestDataActions.setRequestFail());
                return;
            };
            var dataObj = eval(data.results[0]);
            dispatch(requestDataActions.setRequestSuccess());
      });
    }
}

function receiveGetYFTAlarm(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        }
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataObj = eval(data.results[0]);
        var alarms = dataObj.ALARMS;
        var alarmConfig = dataObj.ALARMCONFIG;
        // _this.yftAlarmData = eval("(" + alarms + ")");
        // _this.yftAlarmRuleData = eval("(" + alarmConfig + ")");
        dispatch(setYFTAlarmData(eval("(" + alarms + ")")));
        dispatch(setYFTAlarmRuleData(eval("(" + alarmConfig + ")")));
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetYFTAlarm() {
    return dispatch => {
		oData.getYFTAlarm(data => dispatch(receiveGetYFTAlarm(data)));
    }
}

export function getYFTAlarm() {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetYFTAlarm());
    }
}

function receiveSetYFTAlarm(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        }
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataObj = eval(data.results[0]);
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
        Util.showMessageDialog("提示","保存完成");
        dispatch(getYFTAlarm());
    }
}

function oDataSetYFTAlarm(params) {
    return dispatch => {
		oData.setYFTAlarm(params, data => dispatch(receiveSetYFTAlarm(data)));
    }
}

export function setYFTAlarm(params) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataSetYFTAlarm(params));
    }
}

function receiveGetAlarmIssued(data) {
    return dispatch => {
        if(data.results.length == 0){
            dispatch(requestDataActions.setRequestFail());
            Util.showMessageDialog("提示","获取告警规则失败。");
            // _this.emit("change");
            return;
        }
        //通过eval() 函数可以将JSON字符串转化为对象
        var dataObj = eval(data.results[0]);
        var alarmIssued = dataObj.ALARMISSUED;
        var equipmentType = dataObj.EQUIPMENTTYPE;
        var monitorType = dataObj.MONITORTYPE;
        // _this.alarmIssuedTableData = eval("(" + alarmIssued + ")");
        // _this.alarmIssuedEquipmentType = eval("(" + equipmentType + ")");
        // _this.alarmIssuedMonitorType = eval("(" + monitorType + ")");
        dispatch(setAlarmIssuedTableData(eval("(" + alarmIssued + ")")));
        dispatch(setAlarmIssuedEquipmentType(eval("(" + equipmentType + ")")));
        dispatch(setAlarmIssuedMonitorType(eval("(" + monitorType + ")")));
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetAlarmIssued() {
    return dispatch => {
		oData.getAlarmIssued(data => dispatch(receiveGetAlarmIssued(data)));
    }
}

export function getAlarmIssued() {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetAlarmIssued());
    }
}

function receiveSetAlarmIssued(response) {
    return dispatch => {
        if(response) {
            //console.log("保存成功");
            // _this.emit("change");
            dispatch(requestDataActions.setRequestSuccess());
        }
        else {
            //console.log("保存失败");
            dispatch(requestDataActions.setRequestFail());
            Util.showMessageDialog("提示","保存告警规则失败。");
            // _this.emit("change");
        }
    }
}

function oDataSetAlarmIssued(params) {
    return dispatch => {
		oData.setAlarmIssued(params, response => dispatch(receiveSetAlarmIssued(response)));
    }
}

export function setAlarmIssued(params) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataSetAlarmIssued(params));
    }
}

function receiveDeleteAlarmIssued(response) {
    return dispatch => {
        if(response) {
            //console.log("删除成功");
            // _this.emit("change");
            dispatch(requestDataActions.setRequestSuccess());
        }
        else {
            //console.log("删除失败");
            dispatch(requestDataActions.setRequestFail());
            Util.showMessageDialog("提示","删除告警规则失败。");
            // _this.emit("change");
        }
    }
}

function oDataDeleteAlarmIssued(params) {
    return dispatch => {
		oData.deleteAlarmIssued(params, response => dispatch(receiveDeleteAlarmIssued(response)));
    }
}

export function deleteAlarmIssued(params) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataDeleteAlarmIssued(params));
    }
}

function receiveGetAlarmEvent(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        };
        var result = data.results[0];
        var dataobj = eval(result);
        // _this.alarmEventData = eval(dataobj.EVENTDATA);
        // _this.alarmEventCount = eval(dataobj.COUNT);
        // console.log(dataobj);
        dispatch(setAlarmEventData(eval(dataobj.EVENTDATA)));
        dispatch(setAlarmEventCount(eval(dataobj.COUNT)));
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetAlarmEvent(filter) {
    return dispatch => {
		oData.getAlarmEvent(filter, data => dispatch(receiveGetAlarmEvent(data)));
    }
}

export function getAlarmEvent(filter) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetAlarmEvent(filter));
    }
}

function receiveGetAlarmDetails(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        };
        var result = data.results[0];
        var dataobj = eval(result);
        // _this.alarmEventDetails = eval(dataobj.ALARMEVENTDETAIL);
        dispatch(setAlarmEventDetails(eval(dataobj.ALARMEVENTDETAIL)));
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetAlarmDetails(filter) {
    return dispatch => {
		oData.getAlarmDetails(filter, data => dispatch(receiveGetAlarmDetails(data)));
    }
}

export function getAlarmDetails(filter) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetAlarmDetails(filter));
    }
}

function receiveUpdateAlarmEventStatus(data) {
    return (dispatch,getState) => {
        var state = getState();
        dispatch(requestDataActions.setRequestSuccess());
        var filter = state.deviceMonitorReducer.alarmEventCurrentFilter;
        if(filter){
          dispatch(getAlarmEvent(filter));
        };
    }
}

function oDataUpdateAlarmEventStatus(dateObjec) {
    return dispatch => {
		oData.updateAlarmEventStatus(dateObjec, data => dispatch(receiveUpdateAlarmEventStatus(data)));
    }
}

export function updateAlarmEventStatus(dateObjec) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataUpdateAlarmEventStatus(dateObjec));
    }
}

function receiveGetIsCreateWorkOrder(data,that) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        };
        // _this.isCreateWorkOrder = data.results[0].WORKORDERCOUNT;
        dispatch(setIsCreateWorkOrder(data.results[0].WORKORDERCOUNT));
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
        if(that != null && that != ""){
          that.setState({bTouchOrder: true});
        }
    }
}

function oDataGetIsCreateWorkOrder(gbcode,that) {
    return dispatch => {
      if(that != null && that != ""){
        oData.getIsCreateWorkOrder(gbcode, data => dispatch(receiveGetIsCreateWorkOrder(data,that)));
      }else{
        oData.getIsCreateWorkOrder(gbcode, data => dispatch(receiveGetIsCreateWorkOrder(data)));
      };
    }
}

export function get_isCreateWorkOrder(gbcode,that) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        if(that != null && that != ""){
          return dispatch(oDataGetIsCreateWorkOrder(gbcode,that));
        }else{
          return dispatch(oDataGetIsCreateWorkOrder(gbcode));
        };
    }
}

function receiveGetVideoLoss(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        };
        var result = data.results[0];
        var dataobj = eval(result);
        // _this.videoLossData = eval(dataobj.VIDEOLOSSDATA);
        dispatch(setVideoLossData(eval(dataobj.VIDEOLOSSDATA)));
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetVideoLoss(filter) {
    return dispatch => {
		oData.getVideoLoss(filter, data => dispatch(receiveGetVideoLoss(data)));
    }
}

export function get_videoLoss(filter) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetVideoLoss(filter));
    }
}

function receiveGetChannelInfo(data) {
    return dispatch => {
        if(data.results.length == 0){
            // _this.emit("change");
            dispatch(requestDataActions.setRequestFail());
            return;
        };
        var result = data.results[0];
        var dataobj = eval(result);
        // _this.channelInfoData = eval(dataobj.VIDEODATA);
        dispatch(setChannelInfoData(eval(dataobj.VIDEODATA)));
        // _this.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
    }
}

function oDataGetChannelInfo(filter) {
    return dispatch => {
		oData.getChannelInfo(filter, data => dispatch(receiveGetChannelInfo(data)));
    }
}

export function get_channelInfo(filter) {
    return dispatch => {
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetChannelInfo(filter));
    }
}

function receiveGetWorkOrderToMonitorData(data) {
    return dispatch => {
        if(data.results.length == 0) {
            dispatch(requestDataActions.setRequestFail());
            return;
        }
        var baseData = data.results[0].BASEDATA;
        baseData = eval(baseData);
        var otherData = data.results[0].OTHERDATA;
        otherData = eval(otherData);
        // that.videoLossData = [];
        dispatch(setVideoLossData([]));
        if(tp == "摄像机"){
          var List = [];
          for(var i=0;i<otherData.length;i++){
            var param = {
              no:i+1,
              lostduration:otherData[i].LOSTDURATION,
              loststartime:otherData[i].LOSTSTARTTIME,
              lostendtime:otherData[i].LOSTENDTIME
            };
            List.push(param);
          };
        //   that.videoLossData = List;
          dispatch(setVideoLossData(List));
        };
        // that.monitorTableSelectedRowData = baseData[0];
        // that.monitorTableSelectedRowData.LAG = gb;
        // that.monitorTableSelectedRowData.BRAND = baseData[0].BASETYPE;
        dispatch(setMonitorTableSelectedRowData(baseData[0]));
        dispatch(setMonitorTableSelectedRowDataField(gb, baseData[0].BASETYPE));
        // that.emit("change");
        dispatch(requestDataActions.setRequestSuccess());
        $(".operationMonitorInfoDiv").find("#deviceInfoModal").modal("show");
    }
}

function oDataGetWorkOrderToMonitorData(filter) {
    return dispatch => {
		oData.getWorkOrderToMonitorData(filter, data => dispatch(receiveGetWorkOrderToMonitorData(data)));
    }
}

export function getWorkOrderToMonitorData(row) {
    return dispatch => {
        var gb = row.nat;
        var tp = row.pTypeName;
        if(tp!="NVR" && tp!="DVR" && tp!="IPSAN" && tp!="摄像机" && tp!="编码器"){
          Util.showMessageDialog("提示","设备类型不存在");
          return false;
        };
        var filter = [{key:"GB",value:gb},{key:"EQUIPMENTTYPE",value:tp}];
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataGetWorkOrderToMonitorData(filter));
    }
}

function oDataInsertUserFeedBack(param) {
    return dispatch => {
		oData.insertUserFeedBack({
            data: param.data,
            callback: function(resp){
                dispatch(requestDataActions.setRequestSuccess());
                if(param.callback) param.callback(resp);
                // if(!param.noChange) _this.emit("change");
            },
            error: function(resp){
                dispatch(requestDataActions.setRequestFail());
                if(param.error) param.error(resp);
                // if(!param.noChange) _this.emit("change");
            },
        });
    }
}

export function setUserFeedback(param) {
    return dispatch => {
        if(!param.data) return;
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataInsertUserFeedBack(param));
    }
}

function oDataUpdateUserFeedBack(param) {
    return dispatch => {
		oData.insertUserFeedBack({
            data: param.data,
            callback: function(resp){
                dispatch(requestDataActions.setRequestSuccess());
                if(param.callback) param.callback(resp);
                // if(!param.noChange) _this.emit("change");
            },
            error: function(resp){
                dispatch(requestDataActions.setRequestFail());
                if(param.error) param.error(resp);
                // if(!param.noChange) _this.emit("change");
            },
        });
    }
}

export function setUserFeedbackReset(param) {
    return dispatch => {
        if(!param.data) return;
        dispatch(requestDataActions.setRequest());
        return dispatch(oDataUpdateUserFeedBack(param));
    }
}

export function clearMonitorTableViewData() {
  return dispatch => {
    dispatch(setGroupAllColumnData([]));
    dispatch(setMonitorTableColumns([]));
    dispatch(setGroupTableData([]));
    dispatch(setGroupAllShowColumnData([]));
    dispatch(setGroupTableCount(0));
  }
}

export function clearAlarmEventDesViewData() {
  return dispatch => {
    dispatch(setAlarmEventData([]));
    dispatch(setAlarmEventCount(0));
  }
}

export function getChildrenGroups(pid) {
  return dispatch => {
    oData.getChildrenGroups(pid, (data) => {
      dispatch(setChildrenGroup(data.results));
    }, (res) => {
      if (res.errmsg == 'token invalid.') {
        Utils.showInterfaceErrorInfo(res);
      }
      callback && callback();
    });
  }
}

export function getChildrenEquip(pid) {
  return dispatch => {
    oData.getChildrenEquips(pid, (data) => {
      dispatch(setChildrenEquip(data.results));
    }, (res) => {
      if (res.errmsg == 'token invalid.') {
        Utils.showInterfaceErrorInfo(res);
      }
      callback && callback();
    });
  }
}

export function updateGroupSorter(param, monitorTreeObj){
  return dispatch => {
    oData.updateGroupSorter(param,function(){
        monitorTreeObj.props.onClickRefresh("");
        Util.showMessageDialog("提示","保存成功。");
    })
  }
}

export function updateEquipmentSorter(param, monitorTreeObj){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /equipment/update ===
    ofbiz.updateEquipment({
      equipmentId: param.RecId,
      fixedAssetName: param.Title,
    }).then(() => {
        monitorTreeObj.props.onClickRefresh("");
        Util.showMessageDialog("提示","保存成功。");
    }).catch(() => {
        Util.showMessageDialog("提示","保存失败。", 'error');
    });
  }
}

export function changeGroupStatus(param, callback){
  return dispatch => {
    dispatch(requestDataActions.setRequest());
    oData.changeGroupStatus(param,function(){
        callback && callback();
        if(param[1].value == "delete"){
          Util.showMessageDialog("提示","删除成功。");
        }else if(param[1].value == "disable"){
          Util.showMessageDialog("提示","禁用成功。");
        }else if(param[1].value == "start"){
          Util.showMessageDialog("提示","启用成功。");
        }else{
          Util.showMessageDialog("提示","修改成功。");
        };
        dispatch(requestDataActions.setRequestSuccess());
    })
  }
}

export function getTreeNodeAssociation(id, association){
  return (dispatch, getState) => {
    association = association || '';
    if (id) {
      let state = getState();
      let { deviceMonitorTreeMap } = state.deviceMonitorTreeReducer;
      const node = deviceMonitorTreeMap[id];
      association = '/' + node.name + association;
      if (node.pid) {
        association = dispatch(getTreeNodeAssociation(node.pid, association));
      }
    }
    return association;
  }
}

export function updateEccGroup(param, callback){
  return dispatch => {
    var key = '';
    if (param.hasOwnProperty('key')) {
      key = param.key;
      delete param.key;
    }
    const auditData = {
      type: 'edit_group',
      // BoId: param.RecId,
      BoId: 'group',
      desc: param.GroupName,
      OperationAssociation: param.association
    }
    if (key == 'start') {
      auditData.type = 'enable_group';
      param.hasOwnProperty('GroupName') && delete param.GroupName;
    } else if (key == 'disabled') {
      auditData.type = 'disable_group';
      param.hasOwnProperty('GroupName') && delete param.GroupName;
    }
    param.hasOwnProperty('association') && delete param.association;
    // === 已切换到 OFBiz 新接口 /equipmentGroup/update ===
    // 旧字段 RecId/GroupName -> 新字段 groupId/groupName
    // 注：新接口 update 无 Status 字段，启禁功能待后端补充（当前透传 groupName 更新）
    ofbiz.updateGroup({
      groupId: param.RecId,
      groupName: param.GroupName,
      parentGroupId: param.ParentGroupId,
    }).then(data => {
      callback && callback();
      if (key == 'start') {
        Util.showMessageDialog("提示","启用成功。");
      } else if (key == 'disabled') {
        Util.showMessageDialog("提示","禁用成功。");
      } else {
        Util.showMessageDialog("提示","修改成功。");
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
    }).catch(err => {
      callback && callback();
      if (key == 'start') {
        Util.showMessageDialog("提示","启用失败。", 'error');
      } else if (key == 'disabled') {
        Util.showMessageDialog("提示","禁用失败。", 'error');
      } else {
        Util.showMessageDialog("提示","修改失败。", 'error');
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

export function createEccGroup(param, callback){
  return dispatch => {
    const auditData = {
      type: 'add_group',
      BoId: 'group',
      desc: param.GroupName,
      OperationAssociation: param.association
    }
    param.hasOwnProperty('association') && delete param.association;
    // === 已切换到 OFBiz 新接口 /equipmentGroup/create ===
    // 旧字段 GroupName/ParentGroupId -> 新字段 groupName/parentGroupId
    ofbiz.createGroup({
      groupName: param.GroupName,
      parentGroupId: param.ParentGroupId || '',
    }).then(data => {
      callback && callback();
      dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      Util.showMessageDialog("提示","保存成功。");
    }).catch(err => {
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      callback && callback();
      Util.showMessageDialog("提示","保存失败。", 'error');
    });
  }
}

// 删除组及组下面的子组，资源，监测器
export function deleteEccGroup(param, callback){
  return dispatch => {
    // 以下子节点删除仍走旧接口（设备/监测器/告警条件 CRUD 待后续迁移）
    if (param.alarmIds.length) {
      param.alarmIds.map((recId) => {
        oData.deleteMonitorAlarmCondition(recId);
      })
    }
    if (param.monitorIds.length) {
      param.monitorIds.map((item) => {
        dispatch(deleteMonitorProperty(item));
        oData.deleteMonitor(item.monitorId);
      })
    }
    if (param.equipmentIds.length) {
      // === 删子设备已切换到 OFBiz 新接口 /equipment/delete（自动级联删监测器）===
      // 拓扑节点清理已移除（同 deleteEquipment，等拓扑页迁移）
      param.equipmentIds.map((recId) => {
        ofbiz.deleteEquipment(recId);
      })
    }
    // === 分组本身删除已切换到 OFBiz 新接口 /equipmentGroup/delete ===
    // 新接口单次只删一个 groupId，有子节点时返回 400。这里循环逐个删
    // （上面已先把子节点清掉，所以到删分组时应该是空分组）。
    if (param.groupIds.length) {
      const auditData = {
        type: 'delete_group',
        BoId: 'group',
        // BoId: param.RecId,
        desc: param.GroupName,
        OperationAssociation: param.association
      }
      var count = 0, failCount = 0;
      param.groupIds.map((recId) => {
        ofbiz.deleteGroup(recId).then(data => {
          count ++;
          if (count == param.groupIds.length) {
            callback && callback();
            if (!failCount) {
              Util.showMessageDialog("提示","删除成功。");
              dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            } else {
              Util.showMessageDialog("提示","删除失败。");
              dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
            }
          }
        }).catch(err => {
          count ++;
          if (recId == param.RecId) {
            failCount ++;
          }
          if (count == param.groupIds.length) {
            callback && callback();
            Util.showMessageDialog("提示","删除失败。");
            dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          }
        });
      })
    }
  }
}

export function getEccGroupById(param, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /equipmentGroup/getById ===
    // 旧 param 可能是 {id:xxx} 或直接 id；新接口取 groupId
    const groupId = typeof param === 'string' ? param : (param.id || param.RecId);
    ofbiz.getGroupById(groupId).then(re => {
      // 兼容下游期望的 PascalCase 字段（re 直接是新接口返回的分组对象）
      dispatch(setSelectedDeviceGroup(re));
      if (callback) callback(re);
    }).catch(err => {
      // 失败不阻断
    });
  }
}

export function changeEquipmentStatus(param, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 ===
    // 旧 param 是 [{key:'RecId',value:id},{key:'operate',value:'start|disable|delete'}] 格式
    dispatch(requestDataActions.setRequest());
    var equipmentId = '';
    var operate = '';
    if (Array.isArray(param)) {
      param.forEach(item => {
        if (item.key == 'RecId') equipmentId = item.value;
        if (item.key == 'operate') operate = item.value;
      });
    }
    if (operate == 'delete') {
      ofbiz.deleteEquipment(equipmentId).then(() => {
        callback && callback();
        Util.showMessageDialog("提示","删除成功。");
        dispatch(requestDataActions.setRequestSuccess());
      }).catch(() => {
        callback && callback();
        dispatch(requestDataActions.setRequestSuccess());
      });
    } else {
      var equipStatus = operate == 'start' ? 'IT_ES_INUSE' : (operate == 'disable' ? 'IT_ES_IDLE' : '');
      ofbiz.updateEquipment({ equipmentId, EQUIP_STATUS: equipStatus }).then(() => {
        callback && callback();
        if(operate == "start"){
          Util.showMessageDialog("提示","启用成功。");
        }else if(operate == "disable"){
          Util.showMessageDialog("提示","禁用成功。");
        }else{
          Util.showMessageDialog("提示","修改成功。");
        }
        dispatch(requestDataActions.setRequestSuccess());
      }).catch(() => {
        callback && callback();
        dispatch(requestDataActions.setRequestSuccess());
      });
    }
  }
}

export function updateEquipment(param, callback){
  return dispatch => {
    var key = '';
    if (param.hasOwnProperty('key')) {
      key = param.key;
      delete param.key;
    }
    const auditData = {
      type: 'edit_resource',
      // BoId: param.RecId,
      BoId: 'resource',
      desc: param.name,
      OperationAssociation: param.association
    }
    if (key == 'start') {
      auditData.type = 'enable_resource';
      param.hasOwnProperty('name') && delete param.name;
    } else if (key == 'disabled') {
      auditData.type = 'disable_resource';
      param.hasOwnProperty('name') && delete param.name;
    }
    param.hasOwnProperty('association') && delete param.association;
    // === 已切换到 OFBiz 新接口 /equipment/update ===
    // 旧字段 RecId→equipmentId，EquipmentStatus→EQUIP_STATUS（启用good/禁用disabled）
    var equipStatus = param.EquipmentStatus;
    if (key == 'start') equipStatus = 'IT_ES_INUSE';
    if (key == 'disabled') equipStatus = 'IT_ES_IDLE';
    ofbiz.updateEquipment({
      equipmentId: param.RecId,
      fixedAssetName: param.Title,
      EQUIP_STATUS: equipStatus,
    }).then(data => {
      callback && callback();
      if (key == 'start') {
        Util.showMessageDialog("提示","启用成功。");
      } else if (key == 'disabled') {
        Util.showMessageDialog("提示","禁用成功。");
      } else {
        Util.showMessageDialog("提示","修改成功。");
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
    }).catch(err => {
      callback && callback();
      if (key == 'start') {
        Util.showMessageDialog("提示","启用失败。", 'error');
      } else if (key == 'disabled') {
        Util.showMessageDialog("提示","禁用失败。", 'error');
      } else {
        Util.showMessageDialog("提示","修改失败。", 'error');
      }
      dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

// 删除资源及资源下的监测器
export function deleteEquipment(param, callback){
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /equipment/delete ===
    // 新接口删除设备时自动级联删除其下监测器、告警条件、扩展属性（文档10第96行），
    // 无需前端再手动逐个删 alarmIds/monitorIds。
    // 3D 拓扑节点清理（deleteNetworkNode/deleteNetworkRelation2）暂保留旧接口。
    if (param.equipmentIds.length) {
      const auditData = {
        type: 'delete_resource',
        BoId: 'resource',
        desc: param.name,
        OperationAssociation: param.association
      }
      var count = 0;
      param.equipmentIds.map((recId) => {
        // ⚠️ 拓扑节点清理已移除：旧 /bods.svc/NetWorkNode 全局拓扑表已废弃，
        // 新接口 /topo/nodeDelete 需要 nodeId（拓扑节点 ID），删除设备时没有这个上下文。
        // nodeDelete 会自动删关联连线，无需单独 edgeDelete。
        // 等拓扑页专项迁移时再处理拓扑节点的增删。
        ofbiz.deleteEquipment(recId).then(data => {
          count ++;
          if (count == param.equipmentIds.length) {
            callback && callback();
            Util.showMessageDialog("提示","删除成功。");
            dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
          }
        }).catch(err => {
          count ++;
          if (count == param.equipmentIds.length) {
            callback && callback();
            Util.showMessageDialog("提示","删除失败。", 'error');
            dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
          }
        });
      })
    }
  }
}

// 修改监测器
export function updateMonitor(param, callback, hideTip){
  return dispatch => {
    var key = '';
    if (param.hasOwnProperty('key')) {
      key = param.key;
      delete param.key;
    }
    const auditData = {
      type: 'edit_monitor',
      // BoId: param.RecId,
      BoId: 'monitor',
      desc: param.name,
      OperationAssociation: param.association
    }
    if (key == 'start') {
      auditData.type = 'enable_monitor';
    } else if (key == 'disabled') {
      auditData.type = 'disable_monitor';
    }
    const createAudit = param.hasOwnProperty('association') ? true : false;
    param.hasOwnProperty('name') && delete param.name;
    param.hasOwnProperty('association') && delete param.association;
    // === 已切换到 OFBiz 新接口 /monitor/enable|disable|update ===
    var monitorId = param.RecId;
    var monitorPromise;
    if (key == 'start') {
      monitorPromise = ofbiz.enableMonitor(monitorId);
    } else if (key == 'disabled') {
      monitorPromise = ofbiz.disableMonitor(monitorId);
    } else {
      // 排序等普通编辑走 update
      monitorPromise = ofbiz.updateMonitor({ monitorId, fixedAssetName: param.Title });
    }
    monitorPromise.then(function(){
        callback && callback(true);
        if (!hideTip) {
          if (key == 'start') {
            Util.showMessageDialog("提示","启用成功。");
          } else if (key == 'disabled') {
            Util.showMessageDialog("提示","禁用成功。");
          } else {
            Util.showMessageDialog("提示","修改成功。");
          }
        }
        createAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
    }).catch(() => {
      callback && callback(false);
      if (!hideTip) {
        if (key == 'start') {
          Util.showMessageDialog("提示","启用失败。", 'error');
        } else if (key == 'disabled') {
          Util.showMessageDialog("提示","禁用失败。", 'error');
        } else {
          Util.showMessageDialog("提示","修改失败。", 'error');
        }
      }
      createAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
    });
  }
}

// 删除监测器
export function deleteMonitor(param, callback, hideTip){
  return dispatch => {
    const monitorId = param.monitorId;
    console.log('[deleteMonitor] 开始 monitorId=', monitorId, 'monitorType=', param.monitorType);
    dispatch(deleteMonitorProperty(param));
    const auditData = {
      type: 'delete_monitor',
      BoId: 'monitor',
      desc: param.name,
      OperationAssociation: param.association
    }
    const createAudit = param.hasOwnProperty('association') ? true : false;
    // 告警条件清理暂保留旧接口（告警规则下轮迁移）
    oData.getMonitorAlarmCondition(monitorId, (data) => {
      console.log('[deleteMonitor] oData告警条件回调 monitorId=', monitorId, 'data=', data);
      if (data && data.length) {
        data.map((item) => {
          oData.deleteMonitorAlarmCondition(item.RecId);
        });
      }
      // === 监测器本身删除已切换到 OFBiz 新接口 /monitor/delete ===
      // 新接口自动级联删配置和指标（文档06第89行）
      console.log('[deleteMonitor] 发送 OFBiz 删除请求 /monitor/delete monitorId=', monitorId);
      ofbiz.deleteMonitor(monitorId).then(() => {
        console.log('[deleteMonitor] 删除成功 monitorId=', monitorId);
        callback && callback(true);
        if (!hideTip) {
          Util.showMessageDialog("提示","删除成功。");
        }
        createAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
      }).catch((err) => {
        console.log('[deleteMonitor] 删除失败 monitorId=', monitorId, 'err=', err);
        callback && callback(false);
        createAudit && dispatch(createOperationAudit({ ...auditData, OperationResults: 0 }));
      });
    });
  }
}
// 删除监测器 属性数据，Mysql计数器等
export function deleteMonitorProperty(param, callback) {
  return dispatch => {
    if (param.monitorType == 'Mysql') {
      equipmentOdata.getMySqlMonitorPropertyCounter(param.monitorId, (data) => {
        data.length && data.map((item) => {
          equipmentOdata.deleteMonitorPropertyCounter(item.RecId);
        });
      })
    } else if (param.monitorType == 'Script' || param.monitorType == 'AgentScript') {
      equipmentOdata.getMonitorsEntryAliasDataFromID(param.monitorId, function(data){
        data.results.length && data.results.map((item) => {
          equipmentOdata.deleteMonitorPropertyEntryAlias(item.RecId);
        });
      });
    } else if (param.monitorType == 'SnmpMIB') {
       equipmentOdata.getMySqlMonitorPropertyCounter(param.monitorId, (oldData)=>{
         oldData.forEach((ocd) => {
           equipmentOdata.deleteMonitorPropertyCounter(ocd.RecId);
         });
       });
    }
  }
}

// 修改子组排序状态
export function updateEccGroupSorter(param, callback, auditData){
  return dispatch => {
    let failCount = 0;
    if (param.groups.length) {
      var count = 0;
      // === 分组排序已切换到 OFBiz 新接口 /equipmentGroup/update ===
      // item 是 {RecId, Sorter, GroupName...}，映射到 {groupId, groupName}
      param.groups.map((item) => {
        ofbiz.updateGroup({
          groupId: item.RecId,
          groupName: item.GroupName,
          parentGroupId: item.ParentGroupId,
        }).then(data => {
          if (!param.equipments.length) {
            count ++;
            if (count == param.groups.length) {
              callback && callback();
              Util.showMessageDialog("提示","修改成功。");
              auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
            }
          }
        }).catch(err => {
          failCount ++;
          if (!param.equipments.length) {
            count ++;
            if (count == param.groups.length) {
              callback && callback();
              if (failCount) {
                Util.showMessageDialog("提示","修改失败。", 'error');
              }
            }
          }
        });
      })
    }
    if (param.equipments.length) {
      var count = 0;
      // === 设备排序已切换到 OFBiz 新接口 /equipment/update ===
      param.equipments.map((item) => {
        ofbiz.updateEquipment({
          equipmentId: item.RecId,
          fixedAssetName: item.Title,
        }).then(() => {
          count ++;
          if (count == param.equipments.length) {
            callback && callback();
            Util.showMessageDialog("提示","修改成功。");
            auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
          }
        }).catch(() => {
          count ++;
          failCount ++;
          if (count == param.equipments.length) {
            callback && callback();
            if (failCount) {
              Util.showMessageDialog("提示","修改失败。", 'error');
            }
          }
        });
      })
    }
  }
}

export function updateResourceSorter(param, callback, auditData, noTip){
  return dispatch => {
    let failCount = 0;
    if (param.monitors.length) {
      var count = 0;
      // === 监测器排序已切换到 OFBiz 新接口 /monitor/update ===
      param.monitors.map((item) => {
        ofbiz.updateMonitor({
          monitorId: item.RecId,
          fixedAssetName: item.Title,
        }).then(() => {
          count ++;
          if (count == param.monitors.length) {
            callback && callback();
            if (!noTip) {
              Util.showMessageDialog("提示","修改成功。");
            }
            auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
          }
        }).catch(() => {
          count ++;
          failCount ++;
          if (count == param.monitors.length) {
            callback && callback();
            if (!noTip) {
              Util.showMessageDialog("提示","修改成功。");
            }
            auditData && dispatch(createOperationAudit({ ...auditData, OperationResults: 1 }));
          }
        });
      })
    }
  }
}

//获取监测器阀值（实例级告警条件配置）
export function getThresholdList(ids, callback){
  return dispatch => {
    // === /bods.svc/alarms 旧接口已下线，无新文档接口 ===
    // 旧 alarms 实体（实例级告警条件 AlarmStatus/Operator/AlramValue/relation）
    // 新架构中由 FixedAssetAttribute(WARN_THRESHOLD/ERROR_THRESHOLD/THRESHOLD_OP) 承载，
    // 文档未提供按 monitorId 查询该配置的接口。
    // 降级：回调空数组（不调旧接口、不误登出），保证设备详情页的
    // setMonitorView(4) 切换逻辑不被旧接口失败阻断；详情页"告警条件"摘要区域留空。
    // 注意：回调须保持异步（旧接口是一次网络请求）。树上右键"刷新监测器"链路
    // openResourcePanel('refresh_resource') 后紧跟 getThresholdList 回调里才发
    // refreshMonitorByStep，而其入口有 $('#PanelHeaderTitle').length 守卫——
    // 若同步回调，面板 DOM 尚未渲染，守卫直接 return，导致一个请求都不发。
    dispatch(setThresholdList([]));
    setTimeout(() => { callback && callback([]); }, 0);
  }
}

//获取巡检日志查询数据
export function getCheckLogSearchData(params, callback) {
  return (dispatch, getState) => {
    let state = getState();
    let { deviceMonitorTreeMap } = state.deviceMonitorTreeReducer;
    let monitors = params.monitors;
    let checkLogSearchData = [];
    let count = 0;
    monitors.forEach((monitor, index) => {
      let filters = {
        monitorId: monitor.monitorId || monitor.RecId || monitor.id,
        startTime: params.startTime,
        endTime: params.endTime,
      };
      ofbiz.getReportMonitorLogs(filters).then((res)=>{
        count++;
        const data = normalizeReportMonitorLogs(res);
        let _data = data.filter(item => {
          switch (params.operate) {
            case ">=":
              return item.MonitorEntry === params.MonitorEntry && item.MonitorIntValue >= params.MonitorIntValue;
            case ">":
              return item.MonitorEntry === params.MonitorEntry && item.MonitorIntValue > params.MonitorIntValue;
            case "<=":
              return item.MonitorEntry === params.MonitorEntry && item.MonitorIntValue <= params.MonitorIntValue;
            case "<":
              return item.MonitorEntry === params.MonitorEntry && item.MonitorIntValue < params.MonitorIntValue;
            case "=":
              return item.MonitorEntry === params.MonitorEntry && item.MonitorIntValue === params.MonitorIntValue;
            default:
          }
        });
        let total = 0;
        let _general = 0;
        let _max = 0;
        let _min = Infinity;
        let _newleast = 0;
        let _newleasttime = '';
        let _maxtime = '';
        if (_data.length > 0) {
          _newleast = _data[_data.length - 1].MonitorIntValue;
          _newleasttime = _data[_data.length - 1].LogTime;
          _data.forEach((c) => {
            let intValue = c.MonitorIntValue;
            total += intValue;
            if (_max < intValue) {
              _max = intValue;
              _maxtime = c.LogTime;
            }
            if (_min > intValue) {
              _min = intValue;
            }
          });
          if (total != 0) {
            _general = total / _data.length;
          }
        }
        if (_min === Infinity) {
          _min = 0;
        }
        checkLogSearchData.push({
          entry: params.MonitorEntry,
          entry_zh: nls[params.MonitorEntry] || params.MonitorEntry,
          general: Math.round(_general*100)/100,
          max: Math.round(_max*100)/100,
          min: Math.round(_min*100)/100,
          newleast:  Math.round(_newleast*100)/100,
          newleasttime: _newleasttime,
          maxtime: _maxtime,
          equipment_name: deviceMonitorTreeMap[monitor.EquipmentId].name,
          monitor_name: monitor.name,
          key: monitor.RecId
        });
        if (count === monitors.length) {
          // setTimeout(()=>{
            // console.log("checkLogSearchData:", checkLogSearchData);
            dispatch(setCheckLogSearchData(checkLogSearchData));
            callback && callback(1);
          // }, 200);
        }
      }).catch(function(status) {
        count++;
        if (count === monitors.length) {
          dispatch(setCheckLogSearchData(checkLogSearchData));
          callback && callback(0);
        }
        if (status.errmsg !== 'token invalid.' && !status.errmsg) {
          status.errmsg = "获取巡检日志失败。";
        }
        Utils.showInterfaceErrorInfo(res);
      });
    });
  }
}

//获取对比报表数据
export function getCompareReportData(params, callback){
  return (dispatch, getState) => {
    let state = getState();
    let monitors = params.monitors;
    let compareReportData = {runStatusTable: [], chartsData: {}, totalCount: 0};
    let count = 0;
    monitors.forEach((monitor, index) => {
      let filters = {
        monitorId: monitor.monitorId || monitor.RecId || monitor.id,
        startTime: params.startTime,
        endTime: params.endTime,
        equipmentAndMonitorName: monitor.EquipmentAndMonitorName
      };
      ofbiz.getReportMonitorLogs(filters).then((res) => {
        count++;
        const data = normalizeReportMonitorLogs(res);
        let monitorSummaryData = monitorLogsHandler(filters, data);
        // monitorSummaryData.summaryTableStore.forEach((record) => {
        //   compareReportData.runStatusTable.push(record);
        // });
        compareReportData.runStatusTable = compareReportData.runStatusTable.concat(monitorSummaryData.summaryTableStore);
        compareReportData.totalCount += monitorSummaryData.totalCount;
        let chartsData = monitorSummaryData.chartsData;
        for(let entry in chartsData) {
          if (entry in compareReportData.chartsData) {
            compareReportData.chartsData[entry].data.push({
              name: chartsData[entry].equipmentAndMonitorName,
              data: chartsData[entry].data
            });
          } else {
            compareReportData.chartsData[entry] = {
              entry: entry,
              entry_zh: chartsData[entry].name,
              returnType: chartsData[entry].returnType,
              time: chartsData[entry].time,
              times: chartsData[entry].times,
              data: [{
                name: chartsData[entry].equipmentAndMonitorName,
                data: chartsData[entry].data
              }]
            };
          }
        }
        if (count === monitors.length) {
          // setTimeout(()=>{
            // console.log("compareReportData:",compareReportData);
            dispatch(setCompareReportData(compareReportData));
            callback && callback(1);
          // }, 200);
        }
      }).catch((status) => {
        count++;
        if (count === monitors.length) {
          dispatch(setCompareReportData(compareReportData));
          callback && callback(0);
          if (status.errmsg !== 'token invalid.' && !status.errmsg) {
            status.errmsg = "获取对比报表数据失败。";
          }
          Utils.showInterfaceErrorInfo(status);
        }
      });
    });
  }
}

//获取监测器日志
export function getMonitorLogs(filters, callback){
  return dispatch => {
    const query = {
      ...filters,
      monitorId: filters.monitorId || filters.MonitorId
    };
    delete query.MonitorId;
    ofbiz.getReportMonitorLogs(query).then((res) => {
      const data = normalizeReportMonitorLogs(res);
      let monitorSummaryData = monitorLogsHandler(filters, data);
      dispatch(setMonitorSummaryData(monitorSummaryData));
      callback && callback(true, monitorSummaryData);
    }).catch((status) => {
      dispatch(setMonitorSummaryData({summaryStatus: [0, 0, 0, 0]}));
      callback && callback(false);
      Util.showMessageDialog("提示","获取监测器日志失败。");
    });
  }
}

function normalizeReportMonitorLogs(res) {
  const list = Array.isArray(res) ? res : (res && (res.items || res.list)) || [];
  return list.map((item) => {
    const hasIntValue = item.MonitorIntValue !== undefined && item.MonitorIntValue !== null && item.MonitorIntValue !== '';
    return {
      ...item,
      CreatedDateTime: item.CreatedDateTime || item.LogTime,
      LogTime: item.LogTime || item.CreatedDateTime,
      IsReturnInt: item.IsReturnInt !== undefined ? item.IsReturnInt : hasIntValue,
      IsMainReturn: item.IsMainReturn !== undefined ? item.IsMainReturn : !hasIntValue,
    };
  });
}

//监测器日志数据处理函数
function monitorLogsHandler(filters, data){
  let monitorSummaryData = {summaryStatus: [0, 0, 0, 0], startTime: filters.startTime, endTime: filters.endTime, totalCount: data.length};
  let selectData = [];
  let summaryTableStore = [];
  let chartsData = {};
  data.forEach((item) => {
    switch (item.MonitorStatus) {
      case 'good':
        monitorSummaryData.summaryStatus[0]++;
        break;
      case 'warning':
        monitorSummaryData.summaryStatus[1]++;
        break;
      case 'error':
        monitorSummaryData.summaryStatus[2]++;
        break;
      case 'disabled':
        monitorSummaryData.summaryStatus[3]++;
        break;
      default:
    }
    if (selectData.indexOf(item.MonitorEntry) === -1) {
      selectData.push(item.MonitorEntry);
      if (item.IsReturnInt) {
        chartsData[item.MonitorEntry] = {
          returnType: "int",
          name: nls[item.MonitorEntry] || item.MonitorEntry,
          data: [item.MonitorIntValue],
          time: [Util.newDate(item.CreatedDateTime).Format("MM-dd HH:mm")],
          times: [item.CreatedDateTime],
          equipmentAndMonitorName: filters.equipmentAndMonitorName
        };
      } else if (item.IsMainReturn) {
        chartsData[item.MonitorEntry] = {
          returnType: 'string',
          name: nls[item.MonitorEntry] || item.MonitorEntry,
          data: [item.MonitorStringValue],
          time: [Util.newDate(item.CreatedDateTime).Format("MM-dd HH:mm")],
          times: [item.CreatedDateTime],
          equipmentAndMonitorName: filters.equipmentAndMonitorName
        };
      } else {
        if (item.MonitorEntry === 'STATUS_PORT') { //返回值类型变化属性
          chartsData[item.MonitorEntry] = {
            returnType: "int",
            name: nls[item.MonitorEntry] || item.MonitorEntry,
            data: [item.MonitorIntValue],
            time: [Util.newDate(item.CreatedDateTime).Format("MM-dd HH:mm")],
            times: [item.CreatedDateTime],
            equipmentAndMonitorName: filters.equipmentAndMonitorName
          };
        } else {
          chartsData[item.MonitorEntry] = {
            name: nls[item.MonitorEntry] || item.MonitorEntry,
            data: [item.MonitorIntValue],
            time: [Util.newDate(item.CreatedDateTime).Format("MM-dd HH:mm")],
            times: [item.CreatedDateTime],
            lastTime: item.CreatedDateTime,
            equipmentAndMonitorName: filters.equipmentAndMonitorName
          };
        }
      }
    } else {
      if (item.IsReturnInt) {
        chartsData[item.MonitorEntry].data.push(item.MonitorIntValue);
        chartsData[item.MonitorEntry].time.push(Util.newDate(item.CreatedDateTime).Format("MM-dd HH:mm"));
        chartsData[item.MonitorEntry].times.push(item.CreatedDateTime);
      } else if (item.IsMainReturn) {
        chartsData[item.MonitorEntry].data.push(item.MonitorStringValue);
        chartsData[item.MonitorEntry].time.push(Util.newDate(item.CreatedDateTime).Format("MM-dd HH:mm"));
        chartsData[item.MonitorEntry].times.push(item.CreatedDateTime);
      }
    }

  });
  selectData.forEach((_entry) => {
    let total = 0;
    let _general = 0;
    let _max = 0;
    let _min = Infinity;
    let _newleast = 0;
    let _newleasttime = '';
    let _maxtime = '';
    if (chartsData[_entry]&&chartsData[_entry].returnType === "int") {
      _newleast = chartsData[_entry].data[chartsData[_entry].data.length -1];
      _newleasttime = chartsData[_entry].time[chartsData[_entry].time.length -1]
      chartsData[_entry].data.forEach((c, index) => {
        total += c;
        if (_max < c) {
          _max = c;
          _maxtime = chartsData[_entry].times[index];
        }
        if (_min > c) {
          _min = c;
        }
      });
      if (total != 0) {
        _general = total / chartsData[_entry].data.length;
      }
    }
    if (_min === Infinity) {
      _min = 0;
    }
    summaryTableStore.push({
      entry: _entry,
      entry_zh: nls[_entry] || _entry,
      general: Math.round(_general*100)/100,
      max: Math.round(_max*100)/100,
      min: Math.round(_min*100)/100,
      newleast:  Math.round(_newleast*100)/100,
      newleasttime: _newleasttime,
      equipmentAndMonitorName: filters.equipmentAndMonitorName,
      maxtime: _maxtime,
      key: filters.MonitorId + _entry
    });
  });
  monitorSummaryData.selectData = selectData;
  monitorSummaryData.chartsData = chartsData;
  monitorSummaryData.summaryTableStore = summaryTableStore;
  // console.log("monitorSummaryData: ", monitorSummaryData);
  return monitorSummaryData;
}

function getMonitorEntryValue(item) {
  if (item.IsReturnInt) {
    return item.MonitorIntValue;
  } else if (item.IsMainReturn) {
    return item.MonitorStringValue;
  } else {
    return item.MonitorStringValue;
  }
}

export function getMonitorLogsEntry(filters, callback){
  return dispatch => {
    dispatch(setMonitorLogData({summaryStatus: [0, 0, 0, 0]}));
    const query = {
      ...filters,
      monitorId: filters.monitorId || filters.MonitorId
    };
    delete query.MonitorId;
    ofbiz.getReportMonitorLogs(query).then((res) => {
      const data = normalizeReportMonitorLogs(res);
      let monitorLogData = {summaryStatus: [0, 0, 0, 0], logData: []};
      let logData = [], count = 0, monitorEntrys = [];
      if (!data) {
        callback && callback(false);
        return;
      }
      if (!data.length) {
        callback && callback(true);
        return;
      }
      const _logTime = data[0].LogTime;
      for (var i = 0; i < data.length; i++) {
        if (data[i].LogTime == _logTime) {
          monitorEntrys.push({monitorType: filters.MonitorType, key: data[i].MonitorEntry});
        } else {
          break;
        }
      }
      // console.log(monitorEntrys);
      dispatch(getMonitorLocale(monitorEntrys, (locales) => {
        // locales 可能为 undefined（getMonitorLocale 降级），用空对象兜底，再回退本地指标中文映射 nls（properties.js）
        const _locale = (locales && locales[filters.MonitorType]) || {};
        const labelFor = (entry) => _locale[entry] || nls[entry] || entry;
        data.reverse().forEach((item) => {
          const logIndex = logData.findIndex(item1 => item1.LogTime == item.LogTime);
          if (logIndex == -1) {
            count ++;
            switch (item.MonitorStatus) {
              case 'good':
                monitorLogData.summaryStatus[0]++;
                break;
              case 'warning':
                monitorLogData.summaryStatus[1]++;
                break;
              case 'error':
                monitorLogData.summaryStatus[2]++;
                break;
              case 'disabled':
                monitorLogData.summaryStatus[3]++;
                break;
              default:
            }
            logData.push({key: count, MonitorStatus: item.MonitorStatus, LogTime: item.LogTime, [item.MonitorEntry]: getMonitorEntryValue(item),
              entrys: [{entry: item.MonitorEntry, label: labelFor(item.MonitorEntry), value: getMonitorEntryValue(item)}], desc: `${labelFor(item.MonitorEntry)}=${getMonitorEntryValue(item)}`
            });
          } else {
            logData[logIndex][item.MonitorEntry] = getMonitorEntryValue(item);
            logData[logIndex].desc += `,${labelFor(item.MonitorEntry)}=${getMonitorEntryValue(item)}`;
            logData[logIndex].entrys.push({entry: item.MonitorEntry, label: labelFor(item.MonitorEntry), value: getMonitorEntryValue(item)});
          }
        });
        monitorLogData.logData = logData;
        dispatch(setMonitorLogData(monitorLogData));
        callback && callback(true);
      }))
    }).catch((status) => {
      dispatch(setMonitorLogData({summaryStatus: [0, 0, 0, 0]}));
      callback && callback(false);
      Util.showMessageDialog("提示","获取监测器日志失败。");
    });
  }
}

//获取服务器当前时间
export function getServerCurrentTime(callback) {
  return dispatch => {
    // === 已切换到 OFBiz 新接口 /system/currentTime ===
    ofbiz.getCurrentTime().then(data => {
      // 新接口返回 data: { timestamp, datetime, serverTime, timezone, offsetMinutes }
      // 依次取 serverTime / datetime / currentTime，兼容直接时间字符串
      var time = (data && (data.serverTime || data.datetime || data.currentTime))
        || (typeof data === 'string' ? data : '') || '';
      dispatch(setServerCurrentTime(time));
      callback && callback({ currentime: time });
    }).catch(err => {
      dispatch(setServerCurrentTime(''));
      callback && callback({ currentime: '' });
    });
  }
}
